import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, ITravelItems } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';

function VisaPrepAdditionalHistoryStep8Info(props: IVisaPrepForm) {
  const renderTravelDetails = () => {
    const allTravelDetails: React.ReactNode[] = [];
    if (props.travelItems && props.travelItems.length) {
      props.travelItems.forEach((travelDetail: ITravelItems, i: number) => {
        allTravelDetails.push(
          <SummaryGroup title={`Travel details ${i + 1}`} key={`travel-details-${i}`}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRAVEL_DETAILS_COUNTRY}-${i}`}
              label={`Country`}
              value={travelDetail.country}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRAVEL_DETAILS_REASON}-${i}`}
              label={`Reason for travel`}
              value={travelDetail.reason}
            />
            {travelDetail.reason === 'Other - provide details' ? (
              <SummaryRow
                className={'visa-summary'}
                key={`${VQ.TRAVEL_DETAILS_REASON_OTHER}-${i}`}
                label={`Reason for travel (Other)`}
                value={travelDetail.reasonOther}
              />
            ) : null}
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRAVEL_DETAILS_ENTRY_DATE}-${i}`}
              label={`Entry date`}
              fullLabel={'When did you enter this country?'}
              value={travelDetail.entryDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.TRAVEL_DETAILS_EXIT_DATE}-${i}`}
              label={`Exit date`}
              fullLabel={'When did you leave this country?'}
              value={travelDetail.exitDate}
            />
          </SummaryGroup>,
        );
      });
    }
    return allTravelDetails;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_TRAVELLED}
        label={'Has travelled outside residence'}
        fullLabel={'Have you ever travelled outside your country of residence, excluding the UK, in the last 10 years?'}
        value={boolToYesNo(props.hasTravelled)}
      />
      {props.hasTravelled ? (
        <>
          <SummaryRow className={'visa-summary'} label={'How many times?'} value={props.travelItems?.length} />

          <Box as="ol" pl={8} key={'travel-details'}>
            {renderTravelDetails()}
          </Box>
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalHistoryStep8Info;
